import React, { Component } from 'react'

import { Container, Flex } from '@stackhouse/styled-elements'

import Text from '@stackhouse/dashboard-components/Text'
import Button from '@stackhouse/dashboard-components/Button'

import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import { InitialPages } from '../../pages'
import ChangePassword from './changePassword'


class UserInfo extends Component {

    logout = () => {
        const { client, setUser, setPages } = this.props

        client.get('/User/logout')

        setUser(null, null)
        setPages(InitialPages)
        localStorage.removeItem('MENU')
        localStorage.removeItem('USER')
        localStorage.removeItem('USER_TOKEN')
        localStorage.removeItem('LOCKED_SCHEDULED_CHECK')
    }

    changePassword = () => {
        const { client, withLoader, user } = this.props
        const { loginUsername: username } = user
        ChangePassword({ username, client, withLoader })
    }

    render() {
        const { user } = this.props

        if (!user) return null
        const { userCompleteName, role } = user

        return (
            <Container>
                <Container>
                    <Flex alignCenter>
                        <Text block flex={'1 0 0'} noWrap fontWeight={'600'} color={'theme(colors.primary)'} pv={2}>{'User: '}</Text>
                        <Text minWidth={0} block truncate flex={'3 0 0'} noWrap title={userCompleteName}>{userCompleteName}</Text>
                    </Flex>
                    <Flex alignCenter>
                        <Text block flex={'1 0 0'} noWrap fontWeight={'600'} color={'theme(colors.primary)'} pv={2}>{'Role: '}</Text>
                        <Text minWidth={0} block truncate flex={'3 0 0'} noWrap title={role}>{role}</Text>
                    </Flex>
                </Container>
                <Container marginTop={10} marginBottom={5} borderBottom={'1px solid theme(colors.border, #ccc)'} />
                <Flex column>
                    <Button link justifyBetween ph={0} pv={2} title={'Change password'} icon={'vpn_key'} onClick={this.changePassword} />
                    <Button link justifyBetween ph={0} pv={2} title={'Logout'} icon={'exit_to_app'} onClick={this.logout} color={'theme(colors.error,red)'} />
                </Flex>
            </Container>
        )
    }
}


export default withDashboardContext(UserInfo, ({ user, setUser, setPages, client, withLoader }) => ({ user, setUser, setPages, client, withLoader }))